/**
 * Utility function to trigger a refresh of the Gantt chart
 * This can be imported and used anywhere in the application
 * 
 * @param {number|string} projectId - The ID of the project to refresh
 */
const refreshGanttChart = (projectId) => {
  if (!projectId) {
    console.error('Cannot refresh Gantt chart: projectId is required');
    return;
  }
  
  console.log('Triggering manual refresh for Gantt chart of project', projectId);
  
  // First try the standard refresh event
  window.dispatchEvent(new CustomEvent('gantt:refresh', { 
    detail: { projectId: projectId.toString(), timestamp: Date.now() } 
  }));
  
  // Then use the more aggressive force refresh for reliable updates
  window.dispatchEvent(new CustomEvent('FORCE_GANTT_REFRESH', { 
    detail: { projectId: projectId.toString(), timestamp: Date.now() } 
  }));
  
  // Second dispatch after a short delay to ensure a full refresh
  setTimeout(() => {
    console.log('Sending second refresh event for project', projectId);
    window.dispatchEvent(new CustomEvent('gantt:refresh', { 
      detail: { projectId: projectId.toString(), timestamp: Date.now() } 
    }));
  }, 1000);
};

export default refreshGanttChart;